import { Component, Input, ChangeDetectionStrategy } from '@angular/core';
import { CoreModule } from 'app/modules/core.module';

@Component({
  selector: 'app-state-display',
  standalone: true,
  imports: [CoreModule],
  changeDetection: ChangeDetectionStrategy.OnPush,
  template: `
    @switch(state) {
      @case ('loading') {
        <div class="m-3 d-flex justify-content-center align-items-center p-5">
          <div class="spinner-border"></div>
        </div>
      }
      @case ('empty') {
        <div class="text-center p-4 text-muted">
          <i class="fas fa-inbox fa-3x mb-3"></i>
          <p>{{ message }}</p>
        </div>
      }
    }
  `
})
export class StateDisplayComponent {
  @Input() state: string
  @Input() message: string = ''
}
